// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"691b4e2a","41":"70fb1c68","231":"3d38f27c","243":"8eb952ec","453":"eef09ddb","454":"d411bb06","754":"8c9beb19","881":"aec0f063","950":"f3e3f01f"}[chunkId] + ".chunk.js";
};